module.exports = __webpack_public_path__ + "img/desktop_cover_c.de32dc17.png";